import { Skeleton } from "@volca/ui/components/ui/skeleton";
import { Stack } from "@volca/ui/components/ui/stack";
import { Tabs } from "@volca/ui/components/ui/tabs";
import { BusinessSettingsSidebarHeaderSkeleton } from "@/business-settings/common/business-settings-sidebar-header-skeleton";
import { BusinessSettingsSidebarWrapper } from "@/business-settings/common/business-settings-sidebar-wrapper";

export const ReferralSourceSidebarSkeleton = () => (
  <BusinessSettingsSidebarWrapper>
    <BusinessSettingsSidebarHeaderSkeleton />
    <div className="flex-1 overflow-hidden">
      <Stack align="start" gap={0} className="h-full w-full">
        <Tabs className="flex w-full flex-1 flex-col gap-6 overflow-hidden p-6">
          <Skeleton className="h-[58px] w-full"></Skeleton>

          <Stack className="w-full" align="start" gap={2}>
            <Skeleton className="h-4 w-40"></Skeleton>
            <Skeleton className="h-32 w-full"></Skeleton>
          </Stack>

          <Skeleton className="h-[58px] w-full"></Skeleton>

          <Skeleton className="h-[58px] w-full"></Skeleton>

          <Stack align="start" direction="row" gap={4}>
            <Skeleton className="h-10 w-39"></Skeleton>
            <Skeleton className="h-10 w-26"></Skeleton>
          </Stack>

          <Skeleton className="h-px w-full"></Skeleton>

          <Skeleton className="h-11 w-full"></Skeleton>
        </Tabs>
      </Stack>
    </div>
  </BusinessSettingsSidebarWrapper>
);
